import React, {useEffect, useState} from "react"
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation} from 'react-router-dom';
import Box from '@mui/material/Box';
import logo from './assets/the_burn_primary_logo_white_RGB.png'

const pages = [
    {"name": "Classes", "path": "class"},
    {"name": "Schedule", "path": "schedule"},
    {"name": "Membership", "path": "membership"},
    {"name": "About Us", "path": "about"},
    {"name": "FAQ", "path": "faq"},
];

export default function SiteAppBar() {
    const [navBackground, setNavBackground] = useState(true)
    const [currentPath, setCurrentPath] = useState(window.location.pathname)
    const location = useLocation()
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseNavMenu = (linkType) => {
        setAnchorEl(null);
        switch (linkType) {
            case "class":
                window.location.href = "/classes"
                break;
            case "schedule":
                window.location.href = "/classes/schedule"
                break;
            case "membership":
                window.location.href = "/membership"
                break;
            case "about":
                window.location.href = "/about"
                break;
            case "faq":
                window.location.href = "/faq"
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        setCurrentPath(location.pathname)
        if (location.pathname !== "/" | window.scrollY > 20) {
            setNavBackground(false)
        } else {
            setNavBackground(true)
        }
    }, [location])

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY < 20 && currentPath === "/") {
                setNavBackground(true)
            } else {
                setNavBackground(false)
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [currentPath])

    return (
        <div>
            <AppBar color={navBackground ? 'transparent' : 'primary'} postion="fixed">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Button onClick={() => handleCloseNavMenu()} href='/'>
                            <Box
                                component="img"
                                sx={{
                                    height: 40,
                                    width: 183,
                                }}
                                alt="Logo."
                                src={logo}
                                />
                        </Button>

                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' }, justifyContent: "right" }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={() => handleCloseNavMenu()}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}>
                                {pages.map(page => (
                                    <MenuItem key={page.name} onClick={() => handleCloseNavMenu(page.path)}>
                                        <Typography textAlign="center">{page.name}</Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: "right" }}>
                            {pages.map((page) => (
                            <Button
                                key={page.name}
                                onClick={() => handleCloseNavMenu(page.path)}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page.name}
                            </Button>
                            ))}
                        </Box>
                    </Toolbar>
                </Container>    
            </AppBar>
            {!navBackground && <Toolbar />}
        </div>
    )
}
